import { type ContentComponent, type PullQuoteSectionContent } from '../../../../types/construct.types';
import { RichText } from '../rich-text/rich-text.handler';

export const PullQuoteSection: ContentComponent<PullQuoteSectionContent> = ({ content }) => {
	return <RichText className="w-auto w-100-ns ma5 tc f3 i" rawHtml={content.fields.body_copy.richText} />;
};
